import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import getEnvironmentVar from 'shared/utils/getEnvironmentVar';

export default async function fetchPredictionDetails(
  placeId: string,
  lambdaUrl: string,
) {
  const apiUrl = `${lambdaUrl}${getEnvironmentVar('EXPO_GOOGLE_PLACES_API_BASE_URL')}/details/json?key=${getEnvironmentVar('EXPO_GOOGLE_GEOCODE_PLACES_API_KEY')}&place_id=${placeId}`;

  return unauthenticatedFetch(apiUrl, {
    method: 'POST',
  });
}
